import React from 'react';

interface MobileBrandLogoProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const MobileBrandLogo: React.FC<MobileBrandLogoProps> = ({
  width = 52.29,
  height = 66.26,
  className,
  style,
  title,
}) => (
  <svg
    id="Comps"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    width={width}
    height={height}
    role={title ? 'img' : undefined}
    aria-hidden={title ? undefined : true}
    aria-label={title}
    viewBox="0 0 52.29 66.26"
  >
    {title ? <title>{title}</title> : null}
    <defs>
      <linearGradient
        id="mobile-brand-logo-lightbulb-gradient"
        data-name="Lightbulb Gradient"
        x1="19.03"
        y1="36.85"
        x2="30.73"
        y2="11.26"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f9f1ce" />
        <stop offset=".57" stopColor="#f8ed9e" />
        <stop offset="1" stopColor="#f8ec7f" />
      </linearGradient>
    </defs>
    <path
      fill="#fff"
      d="M21.24,60.44c-3.38,2.28-8.87,1.55-12.45.08-1.75-.72-3-1.5-3.9-2.3.93,1.36,2.5,2.71,5.02,3.74,3.58,1.47,9.06,2.19,12.45-.08,1.19-.8,1.51-3.02,1.21-2.84-.57.37-1.18.65-1.79.87-.16.2-.33.4-.54.53Z"
    />
    <path
      fill="#fff"
      d="M8.38,51.88s.72.45,1.94.97c2.18.08,5.83.39,9.1,1.42.56-.06,1.14-.14,1.72-.27-5.27-2.85-12.76-2.12-12.76-2.12Z"
    />
    <path
      fill="#fff"
      d="M26.93,43.37c.05,1.28-.8,2.54-1.79,3.08-.05.03-.04.09,0,.11.42.16.84.33,1.27.51.19.08.32.24.4.41.74-.66,1.77-2.34,1.19-3.94-1.08-2.99,12.83-9.85,15.59-13.39,2.26-2.9,3.09-6.29,2.72-9.67-.01-.13-.14-.22-.27-.18-.26.07-.52.16-.78.25,0,2.87-.87,5.7-2.8,8.17-2.76,3.54-16.7,10.4-15.54,14.66Z"
    />
    <path
      fill="#fff"
      d="M24.77,50.03c-11.83-4.96-17.03-1.71-17.28-1.4-.25.31-.45.96-.45.96.32-.15.92-.27,1.68-.36,2.08-.72,7.78-1.7,17.17,2.24.42.18.96,0,1.19-.39l.83-1.45c.24-.41.06-.93-.38-1.12-.25-.11-.5-.21-.75-.31l-.83,1.43c-.23.4-.76.57-1.19.39Z"
    />
    <path
      fill="#fff"
      d="M5.86,53.66c-.23-.31-.41-.65-.52-1.02-.28.14-.55.3-.79.49-.02,0,.32,1.47,2.29,2.96-.94-1.2-1.12-2.17-1.13-2.2-.01-.09.06-.17.15-.24Z"
    />
    <path
      fill="#fff"
      d="M23.33,55.62c-2.37,2.39-9.14,1.67-11.2,1.23-1.51-.32-3.47-.91-4.92-1.91,1.38,1.76,4.09,2.93,6.04,3.35,1.71.37,6.11.72,8.91-.53.1-.06.19-.09.27-.13.01,0,.03-.02.04-.02.44-.23.84-.5,1.17-.83.85-1.07,1.05-2.31.51-3.35,0,0,0,0,0,0,.11.72-.18,1.4-.81,2.19Z"
    />
    <path
      fill="#fff"
      d="M14.22,43.78c2.14-5.64-1.21-10.96-3.37-15.97-1.06-2.47-1.49-4.51-.96-7.21,2.92-11.81,18.78-15.09,28.4-6,.06-.03.12-.07.18-.11C29.05,3.78,11.16,6.32,8.11,18.68c-.54,2.69.28,5.24,1.35,7.7,2.16,5.01,5.79,10.33,3.65,15.96-.87,1.98-1.95,2.17-2.39,2.15,0,.14,0,.27.03.4.84-.2,1.88-.36,3.12-.41.12-.2.24-.44.36-.7Z"
    />
    <path
      fill="#fff"
      d="M48.16,12.76c.02.28.02.59-.03.98-.26,1.39-1.37,3.27-2.89,3.57-5.21,1.04-12.45,5.47-19.26,13.05-1.65,1.83-2.83,4.06-4.7,5.69-.83.62-1.44.73-1.9.6.14.69.88,2.43,3.02.84,1.87-1.63,3.06-3.85,4.7-5.69,5.03-5.6,10.33-9.75,14.78-11.82.04-.03.07-.06.11-.08.26-.11.53-.21.79-.32.19-.08.37-.15.56-.22.08-.03.16-.06.24-.08.39-.14.76-.26,1.13-.36.07-.02.14-.05.21-.07,0,0,.01,0,.02,0,.44-.11.88-.21,1.29-.27,1.54-.21,2.74-2.02,3-3.41.25-1.75-.39-2.32-1.09-2.42Z"
    />
    <path
      fill="#fff"
      d="M18.77,19.5c1.83,2.56,2.98,5.63,3.64,8.76.1-.13.4-.48.82-.96-.73-2.71-1.78-5-3.62-7.26-.25-.3-.53-.47-.84-.54Z"
    />
    <path
      fill="#000"
      d="M44.72,18.92c-.38.11-.76.23-1.13.36-.08.03-.16.06-.24.08-.19.07-.37.15-.56.22-.26.1-.53.2-.79.32-.04.02-.07.05-.11.08-.22.16-.33.42-.26.69.3,1.14.64,3.48-1.29,5.8-2.31,2.78-5.25,4.4-6.39,5.07-9.44,5.53-10.69,12.87-10.69,13.54,0,.29.13.69.2.87-3.85-1.27-7.1-1.58-9.59-1.47-1.24.05-2.29.21-3.12.41-.73.17-1.31.37-1.7.56-2.89,1.42-3.66,4.8-3.71,5.05,0,.01,0,.02-.02.03-.74.55-1.37,1.25-1.85,2.16-.74,1.39-.83,3.51,1.43,5.53.9.8,2.15,1.59,3.9,2.3,3.58,1.47,9.06,2.19,12.45-.08.21-.14.38-.33.54-.53.71-.93.9-2.31.7-2.3,0,0-.03.01-.04.02-.09.04-.18.07-.27.13-2.51,1.47-5.53,1.56-7.86,1.11-3.7-.57-6.02-1.67-7.46-2.77-1.97-1.49-2.32-2.95-2.29-2.96.25-.2.52-.36.79-.49.12.37.3.71.52,1.02.35.49.81.91,1.34,1.28,1.45,1,3.42,1.59,4.92,1.91,2.06.44,8.84,1.16,11.2-1.23.63-.79.92-1.47.81-2.19-.04-.25-.12-.51-.26-.78-2.91-3.46-11.33-3.9-15.16-3.43-.76.09-1.36.22-1.68.36,0,0,.19-.66.45-.96.25-.31,5.46-3.56,17.28,1.4.42.18.96,0,1.19-.39l.83-1.43v-.02c.14-.23.13-.49.03-.71-.08-.17-.21-.33-.4-.41-.43-.18-.85-.35-1.27-.51-.05-.02-.05-.08,0-.11.99-.54,1.84-1.81,1.79-3.08-1.16-4.26,12.79-11.12,15.54-14.66,1.93-2.47,2.8-5.29,2.8-8.17,0-.5-.02-1-.07-1.5-.01-.12-.13-.2-.25-.18,0,0-.01,0-.02,0-.07.02-.14.05-.21.07ZM19.42,54.27c-3.82.41-7.13-.59-9.1-1.42-1.22-.52-1.94-.97-1.94-.97,0,0,7.49-.73,12.76,2.12-.58.13-1.15.21-1.72.27Z"
    />
    <path
      fill="#000"
      d="M13.1,42.34c2.14-5.64-1.49-10.95-3.65-15.96-1.06-2.47-1.89-5.01-1.35-7.7,3.06-12.36,20.94-14.9,30.36-4.18,1.44-.82,2.92-1.55,4.42-2.12-2.91-4.45-8.2-7.43-13.25-8.63C19.62,1.37,8.26,7.32,5.45,16.65c-.44,1.45-2.63,7.2.95,13.69,3.02,4.72,4.16,10.89,3.52,11.7-.58.73-.44,2.33.73,2.44.02,0,.04,0,.07,0,.44.02,1.52-.17,2.39-2.15Z"
    />
    <path
      fill="#6f8839"
      d="M38.47,14.49c-.06.03-.12.07-.18.11-6.94,4.01-12.9,10.27-15.06,12.7-.43.48-.72.83-.82.96-.66-3.13-1.81-6.2-3.64-8.76-.21-.29-.41-.57-.64-.85-1.9-2.33-5.74,3.02-4.12,5.01,2.56,3.15,3.87,7.4,4.22,11.41.03.34.33,1.35,1.14,1.58.46.13,1.07.02,1.9-.6,1.87-1.63,3.06-3.85,4.7-5.69,6.81-7.58,14.05-12.01,19.26-13.05,1.52-.3,2.63-2.18,2.89-3.57.06-.39.06-.7.03-.98-.11-1.39-1.08-1.56-1.8-1.41-1.16.23-2.32.58-3.47,1.02-1.5.57-2.98,1.3-4.42,2.12Z"
    />
    <path
      fill="url(#mobile-brand-logo-lightbulb-gradient)"
      d="M18.23,35.07c-.34-4-1.65-8.26-4.22-11.41-1.62-1.99,2.22-7.34,4.12-5.01.22.27.43.56.64.85.31.07.59.23.84.54,1.84,2.26,2.9,4.55,3.62,7.26,2.15-2.43,8.12-8.69,15.06-12.7-9.62-9.09-25.48-5.81-28.4,6-.54,2.69-.11,4.74.96,7.21,2.16,5.01,5.52,10.34,3.37,15.97-.12.26-.24.5-.36.7,2.49-.11,5.75.2,9.59,1.47-.07-.17-.2-.58-.2-.87,0-.66,1.25-8.01,10.69-13.54,1.15-.67,4.08-2.3,6.39-5.07,1.93-2.31,1.6-4.66,1.29-5.8-.07-.27.04-.54.26-.69-4.45,2.07-9.75,6.22-14.78,11.82-1.65,1.83-2.83,4.06-4.7,5.69-2.14,1.6-2.89-.15-3.02-.84-.82-.23-1.11-1.24-1.14-1.58Z"
    />
    <path
      fill="#fff"
      d="M32.85,49.05c-1.61,0-2.91,1.3-2.91,2.91s1.3,2.91,2.91,2.91,2.91-1.3,2.91-2.91-1.3-2.91-2.91-2.91Z"
    />
    <path
      fill="#000"
      d="M32.48,50.11c.41,0,.72.07.91.22s.29.36.29.65c0,.21-.06.39-.17.54-.11.15-.28.26-.51.32l.9,1.34h-.62c-.09,0-.15-.03-.19-.1,0,0-.57-1.06-.64-1.06-.05,0-.38,0-.38,0v1.16h-.64v-3.07h1.05ZM32.42,51.56c.12,0,.63-.02.63-.49s-.47-.46-.57-.46h-.41v.95h.35Z"
    />
    <path
      fill="#000"
      d="M32.5,48.74c-1.61,0-2.91,1.3-2.91,2.91s1.3,2.91,2.91,2.91,2.91-1.3,2.91-2.91-1.3-2.91-2.91-2.91ZM32.5,54.12c-1.36,0-2.47-1.11-2.47-2.47s1.11-2.47,2.47-2.47,2.47,1.11,2.47,2.47-1.11,2.47-2.47,2.47Z"
    />
  </svg>
);

export default MobileBrandLogo;
